import React from 'react';
import PageHeader from '../components/PageHeader';
import { HotIssuesWorkspace } from '../components/HotIssuesSection';
import { useHotIssues } from '../hooks/useHotIssues';
import './MeetingsPage.css';

const HotIssueCapturePage = () => {
  const api = useHotIssues();
  return (
    <div className="meetings-page hot-issue-capture-page">
      <PageHeader title="M Issues to Discuss" backTo="/admin/meetings" backLabel="← Meetings" />
      <p className="meetings-subtitle">
        Jot an issue down as it comes up. Save this page on your phone.
        It stays on the list until it is resolved, and it is waiting at the next Ministry Lead meeting.
      </p>
      <HotIssuesWorkspace api={api} addOpen autoFocusTitle showAddToggle={false} />
    </div>
  );
};

export default HotIssueCapturePage;
